// extracted by mini-css-extract-plugin
export default {"pageContainer":"MortgageProcess_pageContainer__dU1Gz","hero_image":"MortgageProcess_hero_image__LrPgn","header_border":"MortgageProcess_header_border__4QXZG"};